export const modalityValueToEnumLabel: Record<string, string> = {
  anat: "Structural MRI (anat)",
  mri: "Structural MRI (anat)",
  func: "fMRI (func)",
  fmri: "fMRI (func)",
  dwi: "DWI (dwi)",
  fmap: "Field maps (fmap)",
  perf: "Perfusion (perf)",
  meg: "MEG (meg)",
  eeg: "EEG (eeg)",
  ieeg: "Intracranial EEG (ieeg)",
  beh: "Behavioral (beh)",
  pet: "PET (pet)",
  micr: "microscopy (micr)",
  nirs: "fNIRS (nirs)",
  fnirs: "fNIRS (nirs)",
  motion: "motion (motion)",
  ephys: "Electrophysiology (ephys)", // Add
  atlas: "Atlas (atlas)", // Add
  // nifti: "NIfTI (nifti)",
  // mesh: "Mesh (mesh)",
};
